module.exports = __webpack_public_path__ + "static/media/home03.872d5fc8.png";